import React, { FC } from 'react';
import Row from '../ResponsiveRow/row';
import { NONE } from '../../utils/constants';
import { getFalconBackgroundColorClass } from '../../utils/utils';
import { ComponentWithContentProps, FalconBackgroundColor, GenericSBProps } from '../types';

export interface SpacerSchema extends GenericSBProps {
  height: number;
  mobHeight: number;
  backgroundColor: FalconBackgroundColor;
  desktopHeight: number;
  gradientBackgroundGlobal?: string;
  isFullWidth?: boolean;
}

const Spacer: FC<ComponentWithContentProps<SpacerSchema | any>> = ({ content }) => {
  const backgroundStyles = getFalconBackgroundColorClass(content.backgroundColor);
  const hasGlobalGradient =
    !!content?.gradientBackgroundGlobal && content?.gradientBackgroundGlobal !== NONE;
  const backgroundClass = hasGlobalGradient ? '' : backgroundStyles;
  const backgroundInlineStyle = hasGlobalGradient
    ? { background: content.gradientBackgroundGlobal }
    : undefined;

  const SpacerContent = (
    <>
      {content.height ? (
        <div
          className={`d-none d-sm-block ${backgroundClass}`}
          style={{ height: `${content.height}px`, ...backgroundInlineStyle }}
        ></div>
      ) : (
        <div
          className={`d-none d-sm-block ${backgroundClass}`}
          style={{ height: `${content.desktopHeight}px`, ...backgroundInlineStyle }}
        ></div>
      )}
      <div
        className={`d-block d-sm-none ${backgroundClass} `}
        style={{ height: `${content.mobHeight}px`, ...backgroundInlineStyle }}
      ></div>
    </>
  );

  return content?.isFullWidth === false ? <Row>{SpacerContent}</Row> : <>{SpacerContent}</>;
};

export default Spacer;
